export default __webpack_public_path__ + "static/media/banner_signin.63914953.png";